"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authorizeSigner = exports.attestationSecurityCode = void 0;
function attestationSecurityCode(code) {
    return {
        types: {
            EIP712Domain: [
                { name: 'name', type: 'string' },
                { name: 'version', type: 'string' },
            ],
            AttestationRequest: [{ name: 'code', type: 'string' }],
        },
        primaryType: 'AttestationRequest',
        domain: {
            name: 'Attestations',
            version: '1.0.0',
        },
        message: {
            code: code,
        },
    };
}
exports.attestationSecurityCode = attestationSecurityCode;
var authorizeSigner = function (_a) {
    var account = _a.account, signer = _a.signer, chainId = _a.chainId, role = _a.role, accountsContractAddress = _a.accountsContractAddress;
    return ({
        types: {
            EIP712Domain: [
                { name: 'name', type: 'string' },
                { name: 'version', type: 'string' },
                { name: 'chainId', type: 'uint256' },
                { name: 'verifyingContract', type: 'address' },
            ],
            AuthorizeSigner: [
                { name: 'account', type: 'address' },
                { name: 'signer', type: 'address' },
                { name: 'role', type: 'bytes32' },
            ],
        },
        primaryType: 'AuthorizeSigner',
        domain: {
            name: 'Celo Core Contracts',
            version: '1.0',
            chainId: chainId,
            verifyingContract: accountsContractAddress,
        },
        message: {
            account: account,
            signer: signer,
            role: role,
        },
    });
};
exports.authorizeSigner = authorizeSigner;
//# sourceMappingURL=typed-data-constructors.js.map